<mat-card appearance="outlined" class="new-theme-typography">
    <mat-card-header class="justify-center">
        <mat-card-title>
            Your account is locked
        </mat-card-title>
    </mat-card-header>
    <div class="lendio-mat-card-divider"></div>
    <mat-card-content>
        <p class="mat-body-1">
            To unlock your account, you can <a class="text-blue-400" href="javascript:;" (click)="forgotPasswordDialog()">reset your password</a>
            or reach out to <a class="text-blue-400" href="mailto:lenderoperations@lendio.com">lenderoperations@lendio.com</a> for assistance.
        </p>
        <div class="lendio-mat-card-divider"></div>
        <button mat-flat-button color="primary" (click)="forgotPasswordDialog()" class="w-full">Reset Password</button>
        <div class="lendio-mat-card-divider"></div>
        <div class="text-center mat-body-1">
            <a class="text-blue-400 cursor-pointer" (click)="backToSignIn()">Return to Sign in</a>
        </div>
    </mat-card-content>
</mat-card>
